import { render, staticRenderFns } from "./landing-cta.vue?vue&type=template&id=4dab130e&scoped=true&"
import script from "./landing-cta.vue?vue&type=script&lang=js&"
export * from "./landing-cta.vue?vue&type=script&lang=js&"
import style0 from "./landing-cta.vue?vue&type=style&index=0&id=4dab130e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dab130e",
  null
  
)

export default component.exports